export const validateExhibitor = (data, isEdit = false) => {
  const errors = {};

  if (!data.title?.trim())
    errors.title = "Exhibitor name is required";

  if (!data.exhibitor_category)
    errors.exhibitor_category = "Category is required";

  if (!data.country)
    errors.country = "Country is required";
  
  if (!data.overview)
    errors.overview = "Overview is required";

  if (!data.email)
    errors.email = "Email is required";
  else if (!/^\S+@\S+\.\S+$/.test(data.email))
    errors.email = "Enter a valid email";

  if (
  data.email &&
  data.manager_email &&
  data.email.trim().toLowerCase() ===
    data.manager_email.trim().toLowerCase()
) {
  errors.email = "Must be different from manager email";
  errors.manager_email = "Must be different from exhibitor email";
}

  if (!isEdit && !data.password?.trim()) {
    errors.password = "Password is required";
  } else if (
    data.password &&
    !/^(?=.*[A-Z])(?=.*\d).{8,}$/.test(data.password)
  ) {
    errors.password =
      "Min 8 chars, 1 uppercase letter & 1 number required";
  }

  if (!data.phone_number)
    errors.phone_number = "Phone number is required";
  else if (!/^[0-9]{7,15}$/.test(data.phone_number))
    errors.phone_number = "Enter a valid phone number";


  /* STALL */
  // if (!data.stallNumber)
  //   errors.stallNumber = "Stall number is required";

  // if (!data.stallSize)
  //   errors.stallSize = "Stall size is required";

  /* MEDIA */
  if (!isEdit && !data.logoImage)
    errors.logoImage = "Logo is required";

  if (!isEdit && !data.bannerImage)
    errors.bannerImage = "Banner is required";
  

  return errors;
};
